<template>
  <div class="home">
    <div class="swiper">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div class="swiper-slide index">
          <div class="logo1"></div>
          <div class="logo2"></div>
          <div class="vision">
            成为保护数字主权、保障数字安全、分享数据价值<br />
            深受客户和生态伙伴信赖的产业智能平台运营商
          </div>
          <div class="mission">
            沉淀行业经验、打造产业智能，推动产业数智升级<br />
            助力经济社会高质量发展
          </div>
        </div>
        <div class="swiper-slide content">
          <div class="banner"></div>
          <div class="bodyleft"></div>
          <div class="bodybottom"></div>
          <div class="bodytitle">
            <span>公司简介</span>
            <i>Company Profile</i>
          </div>
          <div class="profilecon">
            2020年，新奥集团为加快推动产业数智化转型，将总部转型为创值能力平台，成立新奥新智科技有限公司，为新奥集团旗下各产业提供托管支持，协力打造产业互联网。新奥新智致力于成为产业智能平台运营商，依托新奥集团在清洁能源、品质生活领域丰富的产业场景和多年行业运营、企业治理经验，聚焦复杂产业场景，输出产业智能。<br /><br />
            新奥新智建设并运营恩牛产业智能运营平台，围绕“场景是基础、物联是关键、数据是资源、平台是载体、智能是目的、安全是保障”的建设思路，率先聚焦“安、能、碳、质”产业场景，链接需求侧和供给侧，通过“恩牛+行业数智平台”，将场景数据、产业最佳实践共建打造成为产业智能产品，提升产业整体能力。新奥新智以市场化方式为新奥集团旗下聚安网、好气网、泛能网、质采智购、嗯噢哇、来康网等数智平台的建设运营提供全局数智技术支撑，整合新奥集团智能产品与服务，并聚合跨领域综合需求打造、交付智能产品，共同为客户创造价值。
          </div>
        </div>
        <!-- 第三屏开始 -->
        <div class="swiper-slide content">
          <div class="banner"></div>
          <div class="bodyleft"></div>
          <div class="bodybottom"></div>
          <div class="bodytitle">
            <span>发展历程</span>
            <i>Development Path</i>
          </div>
          <div class="fzlccon">
            <li>
              <span>2020年6月</span>
              <p>新奥新智科技有限公司注册成立。</p>
            </li>
            <li>
              <span>2020年9月</span>
              <p>
                新奥新智成立联合学习实验室，借助新奥在能源、健康、生活服务等领域的行业优势和产业物联网基础，打造联合学习核心引擎。
              </p>
            </li>

            <li>
              <span>2021年1月</span>
              <p>
                新奥新智与保定市政府签约建立全面战略合作关系，推进智能城市、能源物联网在保定市建设落地。
              </p>
            </li>
            <li>
              <span>2021年6月</span>
              <p>
                新奥新智与廊坊临空新基建科技有限公司合资注册廊坊新奥数智未来智能城市有限公司，落地廊坊临空智能城市建设。
              </p>
            </li>
            <li>
              <span>2021年8月</span>
              <p>新奥新智正式发布产业智能运营平台——恩牛。</p>
            </li>
            <li>
              <span>2021年9月</span>
              <p>
                新奥新智与廊坊临空管委会共建的廊坊临空经济区智慧城市物联感知实验室挂牌，这是国内首个面向智慧城市全场景智慧物联的实践基地。
              </p>
            </li>
          </div>
        </div>
        <!-- 第三屏结束 -->
        <!-- 第si屏开始 -->
        <div class="swiper-slide content">
          <div class="banner"></div>
          <div class="bodyleft"></div>
          <div class="bodybottom"></div>
          <div class="bodytitle">
            <span>发展历程</span>
            <i>Development Path</i>
          </div>
          <div class="fzlccon">
            <li>
              <span>2021年11月</span>
              <p>
                新奥新智在天津滨海新区注册成立天津新智感知科技有限公司，投资建设天津新智感知产业园，聚焦产业互联网，建设物联感知科技产业园，打造物联传感科技创新策源地和产业生态聚集区。
              </p>
            </li>
            <li>
              <span>2022年5月</span>
              <p>
                新奥新智研发的象云析平台获河北省通信管理局签发河北省首张工业互联网标识二级节点服务许可证。
              </p>
            </li>
            <li>
              <span>2022年9月</span>
              <p>
                新奥新智与天津大学签署《关于物联感知产业领域的合作协议》，计划在5年内出资1亿元，与天津大学合作共建“天大-新奥物联感知研发中心”，围绕物联感知核心关键问题和“卡脖子”技术，开展相关领域的核心技术研发。此外，新奥公益慈善基金会与天津大学北洋教育发展基金会签署《捐赠协议》，无偿捐赠人民币2亿元用于支持天津大学教学科研大楼的建设。
              </p>
            </li>
          </div>
        </div>
        <!-- 第四屏结束 -->
        <!-- 第五屏开始 -->
        <div class="swiper-slide content">
          <div class="banner"></div>
          <div class="bodyleft"></div>
          <div class="bodybottom"></div>
          <div class="ennewlogo"></div>
          <!-- <div class="cont1"></div> -->
          <div class="bodytitle">
            <span
              >保护数字主权 顺畅数字交流 <br />创造数字价值 提供数字服务
            </span>
            <i
              >Protect Digital Sovereignty Promote Digital Communication Create
              Digital Value Provide Digital Services</i
            >
          </div>
          <div class="conp">
            新奥在聚焦提供“安、能、碳、质”运营服务过程中，发现众多企业客户渴望实现数智化转型。新奥新智依托新奥多场景、跨行业实践经验，基于对数智时代的客户需求及产业互联网理念模式的深度认知，围绕“场景是基础、物联是关键、数据是资源、平台是载体、智能是目的、安全是保障”建设思路，秉承“保护数字主权，顺畅数字交流、创造数字价值，提供数字服务”理念，加强物联基础能力、构建数字基础架构，形成产业智能运营平台——恩牛。聚焦四大核心能力，链接生态各方，激发产业智能，助力百行千业实现产业升级。
          </div>
        </div>
        <!-- 第五屏结束 -->
        <!-- 第六屏开始 -->
        <div class="swiper-slide content">
          <div class="banner"></div>
          <div class="bodyleft"></div>
          <div class="bodybottom"></div>
          <!-- <div class="cont2"></div> -->
          <div class="bodytitle">
            <span
              >聚焦四大核心能力 链接生态各方<br />
              激发产业智能助力百行千业实现产业升级
            </span>
            <i>
              Focusing on Four Core Capabilities Linking Ecological Partners
              Stimulating Industrial Intelligence Helping Hundreds of Industries
              to Achieve Industrial Upgrades</i
            >
          </div>
          <div class="num1"></div>
          <div class="num1con">
            依托新奥在百余座城市的公共事业运营经验与技术积累，
            建成了联通多个城市的物联网。
            将跨行业场景的传感器统一在多元化物联网系统之中，
            为客户提供物联能力共享服务和智能化物联解决方案。
          </div>
          <div class="num2"></div>
          <div class="num2con">
            产业数据种类繁多，多源异构，恩牛洞察产业数据特性，
            通过数据治理快速满足企业各类数据消费场景，
            交付安全可信的数据，支持智能能力生产。
          </div>
        </div>
        <!-- 第六屏结束 -->
        <!-- 第七屏开始 -->
        <div class="swiper-slide content">
          <div class="banner"></div>
          <div class="bodyleft"></div>
          <div class="bodybottom"></div>
          <!-- <div class="cont2"></div> -->
          <div class="bodytitle">
            <span
              >聚焦四大核心能力 链接生态各方<br />
              激发产业智能助力百行千业实现产业升级
            </span>
            <i>
              Focusing on Four Core Capabilities Linking Ecological Partners
              Stimulating Industrial Intelligence Helping Hundreds of Industries
              to Achieve Industrial Upgrades</i
            >
          </div>
          <div class="num3"></div>
          <div class="num3con">
            恩牛提供低代码智能工具，与后台强大的AI算法、算力相结合，
            让产业从业者即使不懂编码也可以快速生产智能产品。
          </div>
          <div class="num4"></div>
          <div class="num4con">
            恩牛提供的防攻击体系、多重密钥机制和访问策略控制技术，
            实现“端边网云智”全体系覆盖，为安全生产、稳健发展保驾护航。
          </div>
        </div>
        <!-- 第七屏结束 -->
        <!-- 第ba屏开始 -->
        <div class="swiper-slide content">
          <div class="banner"></div>
          <div class="bodyleft"></div>
          <div class="bodybottom"></div>
          <!-- <div class="cont3"></div> -->
          <div class="bodytitle">
            <span>让产业智能发生</span>
            <i>Make Industrial Intelligence Happen</i>
          </div>
          <div class="profilecon">
            通过不断实践和生态协作，基于恩牛为数智支撑，目前已构建起“恩牛＋行业数智平台”的“1+6”模式：恩牛+共建共赢的安全产业数智平台——聚安网、天然气产业智能生态平台——好气网、能碳产业智能生态平台——泛能网、以全链质控为核心能力的供应链生态平台——质采智购、
            居家品质生活数智平台——来康网、品质旅行数智平台——嗯噢哇。率先聚焦“安、能、碳、质”产业场景，链接需求侧和供给侧，通过“恩牛＋行业数智平台”，将场景数据、产业最佳实践共建打造成为产业智能产品，提升产业整体能力。
          </div>
        </div>
        <!-- 第ba屏结束 -->
        <!-- end -->
        <div class="swiper-slide index">
          <div class="logo1" style="top:150px;"></div>
        </div>
        <!-- end -->
        ...
      </div>
      <!-- If we need pagination -->
      <div class="swiper-pagination"></div>

      <!-- If we need navigation buttons -->
      <!-- <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div> -->

      <!-- If we need scrollbar -->
      <!-- <div class="swiper-scrollbar"></div> -->
    </div>
  </div>
</template>

<script>
import "swiper/swiper-bundle.min.css"; // 所有 Swiper 样式，包括所有模块样式（如导航、分页等）
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from "swiper"; // 导入您需要的模块
export default {
  data() {
    return {};
  },
  methods: {},
  components: {},
  mounted() {
    new Swiper(".swiper", {
      speed: 400,
      spaceBetween: 0,
      direction: "vertical",
      autoplay: {
        delay: 10000
      },
      modules: [Navigation, Pagination, Scrollbar, Autoplay],
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev"
      // },
      // scrollbar: {
      //   el: ".swiper-scrollbar",
      //   draggable: true
      // },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination"
      }
    });
  }
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
  min-height: 1260px;
  overflow: hidden;
  position: relative;
  /* z-index: -10000; */
}
.swiper,
.swiper-slide,
.swiper-wrapper {
  width: 100%;
  height: 100%;
  /* display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center; */
}
.swiper-pagination {
  position: absolute;
  right: 30px;
  top: 50%;
  z-index: 1000;
}

.index {
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to right, #59a2c7, #435faa);
  position: relative;
}
.index .logo1 {
  width: 550px;
  height: 526px;
  left: 100px;
  top: 80px;
  position: absolute;
  background: url(../assets/logo1.png);
  background-size: 100% 100%;
}
.index .logo2 {
  width: 679px;
  height: 97px;
  left: 55px;
  bottom: 60px;
  position: absolute;
  background: url(../assets/logo2.png);
  background-size: 100% 100%;
}
.index .vision {
  width: 750px;
  height: 260px;
  left: 0px;
  top: 870px;
  position: absolute;
  background: url(../assets/visionbg.png);
  background-size: 100% 100%;
  text-align: center;
  font-size: 26px;
  line-height: 200%;
  color: #fff;
  padding-top: 120px;
  box-sizing: border-box;
}
.index .mission {
  width: 750px;
  height: 350px;
  right: 0px;
  top: 600px;
  position: absolute;
  background: url(../assets/missionbg.png);
  background-size: 100% 100%;
  text-align: center;
  font-size: 26px;
  color: #fff;
  line-height: 200%;
  padding-top: 138px;
  box-sizing: border-box;
}

.content {
  width: 100%;
  height: 100%;
  position: relative;
}
.content .banner {
  width: 750px;
  height: 180px;
  background: url(../assets/banner.jpg);
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.content .bodyleft {
  width: 73px;
  height: 307px;
  background: url(../assets/bodyleft.png);
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 250px;
}
.content .bodybottom {
  width: 320px;
  height: 837px;
  background: url(../assets/bodyright.png);
  background-size: 100% 100%;
  position: absolute;
  right: 0;
  bottom: 0;
}
.bodytitle {
  width: 600px;
  height: auto;
  overflow: hidden;
  position: absolute;
  left: 95px;
  top: 200px;
  background: url(../assets/liner.png) top left no-repeat;
  background-size: 110px 3px;
}
.bodytitle span {
  margin-top: 15px;
  float: left;
  display: block;
  width: 600px;
  height: auto;
  font-size: 26px;
  font-weight: bold;
  color: #3a8282;
  text-align: left;
  display: flex; /*Flex布局*/
  display: -webkit-flex; /* Safari */
  align-items: center; /*指定垂直居中*/
  line-height: 35px;
}
.bodytitle i {
  display: block;
  float: left;
  width: 600px;
  height: auto;
  padding: 5px 0;
  overflow: hidden;
  font-size: 16px;
  font-weight: bold;
  color: #abd3d3;
  text-align: left;
  display: flex; /*Flex布局*/
  display: -webkit-flex; /* Safari */
  align-items: center; /*指定垂直居中*/
  line-height: 20px;
  font-weight: normal;
}
.content .profiletit {
  width: 350px;
  height: 75px;
  background: url(../assets/profiletit.png);
  background-size: 100% 100%;
  position: absolute;
  left: 90px;
  top: 220px;
}
.content .fzlctit {
  width: 350px;
  height: 75px;
  background: url(../assets/fzlctit.png);
  background-size: 100% 100%;
  position: absolute;
  left: 90px;
  top: 220px;
}
.content .profilecon {
  width: 560px;
  height: auto;
  position: absolute;
  left: 95px;
  top: 320px;
  font-size: 26px;
  color: #4d9994;
  line-height: 180%;
  text-align: left;
  text-align: justify;
}
.content .fzlccon {
  width: 560px;
  height: auto;
  overflow-y: auto;
  position: absolute;
  left: 95px;
  top: 320px;
  font-size: 26px;
  color: #4d9994;
  line-height: 180%;
  text-align: left;
}
.content .fzlccon li {
  width: 560px;
  height: auto;
  overflow: hidden;
  float: left;
  padding-bottom: 0px;
}
.content .fzlccon li span {
  display: block;
  width: 560px;
  font-size: 20px;
  height: 25px;
  font-weight: bold;
}
.content .fzlccon li p {
  display: block;
  width: 560px;
  float: left;
  font-size: 20px;
  height: auto;
  text-align: justify;
  overflow: hidden;
}
.ennewlogo {
  width: 370px;
  height: 350px;
  position: absolute;
  left: 190px;
  top: 350px;
  background: url(../assets/ennewlogo.png);
  background-size: 100% 100%;
}
.cont1 {
  width: 359px;
  height: 111px;
  background: url(../assets/t1.png);
  background-size: 100% 100%;
  position: absolute;
  left: 90px;
  top: 200px;
}
.content .conp {
  width: 560px;
  height: auto;
  overflow-y: auto;
  position: absolute;
  left: 95px;
  top: 720px;
  font-size: 26px;
  color: #4d9994;
  line-height: 180%;
  text-align: left;
  text-align: justify;
}
.cont2 {
  width: 597px;
  height: 110px;
  background: url(../assets/t2.png);
  background-size: 100% 100%;
  position: absolute;
  left: 90px;
  top: 210px;
}
.cont3 {
  width: 324px;
  height: 75px;
  background: url(../assets/t3.png);
  background-size: 100% 100%;
  position: absolute;
  left: 90px;
  top: 220px;
}
.num1 {
  width: 570px;
  height: 196px;
  background: url(../assets/111.png);
  background-size: 100% 100%;
  position: absolute;
  left: 95px;
  top: 420px;
}
.num3 {
  width: 570px;
  height: 196px;
  background: url(../assets/333.png);
  background-size: 100% 100%;
  position: absolute;
  left: 95px;
  top: 420px;
}
.num2 {
  width: 570px;
  height: 196px;
  background: url(../assets/222.png);
  background-size: 100% 100%;
  position: absolute;
  left: 95px;
  top: 800px;
}
.num4 {
  width: 570px;
  height: 196px;
  background: url(../assets/444.png);
  background-size: 100% 100%;
  position: absolute;
  left: 95px;
  top: 800px;
}
.num1con {
  width: 450px;
  height: auto;
  overflow-y: auto;
  position: absolute;
  left: 220px;
  top: 520px;
  font-size: 24px;
  color: #4d9994;
  line-height: 180%;
  text-align: left;
  text-align: justify;
}
.num2con {
  width: 450px;
  height: auto;
  overflow-y: auto;
  position: absolute;
  left: 220px;
  top: 900px;
  font-size: 24px;
  color: #4d9994;
  line-height: 180%;
  text-align: left;
}
.num3con {
  width: 450px;
  height: auto;
  overflow-y: auto;
  position: absolute;
  left: 220px;
  top: 530px;
  font-size: 24px;
  color: #4d9994;
  line-height: 180%;
  text-align: left;
}
.num4con {
  width: 450px;
  height: auto;
  overflow-y: auto;
  position: absolute;
  left: 220px;
  top: 910px;
  font-size: 24px;
  color: #4d9994;
  line-height: 180%;
  text-align: left;
}
</style>
